import { Box, Text, Flex, Badge, HStack } from "@chakra-ui/react";
import SectionWrapper from "../../components/SectionWrapper";
import { zones } from "../../utils/options";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PrimaryButton from "../../components/PrimaryButton";
import {
  getUpdatedImageUrlWithSize,
  shuffleArray,
  getCloudfrontUrl,
} from "../../utils/helpers";
import Img from "../../components/Img";
const Essentials = ({ zoneImages = {} }) => {
  // console.log({zoneImages})

  return (
    // <Box className="max-w-6xl mx-auto p-6 bg-white">
    <SectionWrapper heading={""}>
      <>
        {/* Category Badge */}
        <Flex justify="center" mb={4}>
          <Badge
            colorScheme="teal"
            variant="solid"
            px={4}
            py={2}
            borderRadius="full"
            fontSize="sm"
            bg="teal.400"
          >
            Category
          </Badge>
        </Flex>

        {/* Title */}
        {zones.map((zone) => (
          <SingleZone zone={zone} zoneImages={zoneImages} key={zone} />
        ))}
      </>
    </SectionWrapper>
    // </Box>
  );
};

const SingleZone = ({ zone, zoneImages }) => {
  const navigate = useNavigate();
  const [widthImg, setWidthImg] = useState([]);
  const [heightImg, setHeightImg] = useState([]);

  useEffect(() => {
    const processImages = async (images) => {
      // console.log(`Processing ${images.length} images for ${zone}`);
      let wImg = [];
      let hImg = [];

      await Promise.all(
        images.map(
          (url) =>
            new Promise((resolve) => {
              const img = new Image();
              // Apply CloudFront URL optimization
              const cloudFrontUrl = getCloudfrontUrl(url);
              let hasTriedFallback = false;

              img.onload = () => {
                // console.log(`Image loaded: ${url}, dims: ${img.width}x${img.height}`);
                const sizedUrl = getUpdatedImageUrlWithSize(url, [1, 1, 2]);
                if (img.width >= img.height) {
                  wImg.push(sizedUrl);
                } else {
                  hImg.push(sizedUrl);
                }
                resolve();
              };

              img.onerror = () => {
                // If CloudFront URL failed and we haven't tried fallback, try original URL
                if (!hasTriedFallback && cloudFrontUrl !== url) {
                  console.warn(
                    `CloudFront URL failed, trying original URL: ${url}`,
                  );
                  hasTriedFallback = true;
                  img.src = url;
                } else {
                  console.error(`Failed to load image: ${url}`);
                  resolve();
                }
              };

              img.src = cloudFrontUrl;
            }),
        ),
      );

      // console.log(`Width images: ${wImg.length}, Height images: ${hImg.length}`);
      setWidthImg(shuffleArray(wImg).flat());
      setHeightImg(shuffleArray(hImg).flat());
    };

    const cached = zoneImages?.[zone];
    // console.log(`Zone: ${zone}, Cached images: ${cached?.length || 0}`);
    if (cached && cached.length) {
      processImages(cached);
    } else {
      setWidthImg([]);
      setHeightImg([]);
    }
  }, [zone, zoneImages]);
  // console.log({ widthImg, heightImg, zone });
  return (
    <>
      <Text
        fontSize="4xl"
        fontWeight="bold"
        color="black"
        textAlign="center"
        mt={6}
        mb={4}
      >
        {zone}
      </Text>

      {/* Images Grid */}
      <HStack
        h={"70vh"}
        //  border={"2px solid red"}
        w={"full"}
      >
        <Box
          w={"33%"}
          h={"100%"}
          overflow={"hidden"}
          rounded={"lg"}
          className="hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
        >
          <Img
            src={
              heightImg?.[0] ? heightImg?.[0] : widthImg?.[widthImg.length - 1]
            }
            alt={`Height Image ${zone}`}
            width="100%"
            height="100%"
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        </Box>
        <Box w={"33%"} h={"100%"} display={"flex"} gap={2} flexDir={"column"}>
          <Box
            h={"50%"}
            flexBasis={"50%"}
            flexGrow={1}
            rounded={"lg"}
            overflow={"hidden"}
            className="hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
          >
            <Img
              src={widthImg?.[0]}
              alt={`Width Image ${zone}`}
              width="100%"
              height="100%"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </Box>
          <Box
            h={"50%"}
            flexBasis={"50%"}
            flexGrow={1}
            rounded={"lg"}
            overflow={"hidden"}
            className="hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
          >
            <Img
              src={widthImg?.[1]}
              alt={`Width Image ${zone}`}
              width="100%"
              height="100%"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </Box>
        </Box>
        <Box
          w={"33%"}
          h={"100%"}
          rounded={"lg"}
          overflow={"hidden"}
          pos={"relative"}
          className="hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
        >
          <Img
            src={
              heightImg?.[1] ? heightImg?.[1] : widthImg?.[widthImg.length - 2]
            }
            alt={`Height Image ${zone}`}
            width="100%"
            height="100%"
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
          <div className="absolute bottom-6 right-6">
            <PrimaryButton
              onClick={() => navigate(`material-filter`, { state: { zone } })}
              className="group relative rounded-full h-16 px-10 shadow-2xl hover:shadow-green-500/40 transform hover:scale-110 active:scale-95 transition-all duration-300 font-bold tracking-wide border-0 bg-gradient-to-r from-green-400 via-green-500 to-emerald-600 hover:from-green-500 hover:via-emerald-600 hover:to-teal-600 overflow-hidden backdrop-blur-sm"
            >
              {/* Animated background overlay */}
              <div className="absolute inset-0 bg-gradient-to-r from-white/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

              {/* Shimmer effect */}
              <div className="absolute inset-0 -translate-x-full group-hover:translate-x-full transition-transform duration-700 bg-gradient-to-r from-transparent via-white/30 to-transparent skew-x-12" />

              <span className="group-hover:tracking-wider transition-all duration-300">
                View More
              </span>
              <span className="relative flex items-center gap-3 z-10">
                <svg
                  className="w-6 h-6 transform group-hover:rotate-12 transition-transform duration-300"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2.5}
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </span>
            </PrimaryButton>
          </div>
        </Box>
      </HStack>

      {/* Navigation */}
      {/* <Flex justify="center" align="center" gap={4} mt={4}>
       
          <Button
            variant="solid"
            colorScheme="teal"
            isRound
            size="lg"
            bg="teal.300"
            _hover={{ bg: "teal.400" }}
            className="shadow-lg"
          >
            <Icon
              icon="material-symbols:arrow-back"
              className="text-white text-xl"
            />
          </Button>

          <Flex gap={2} align="center">
            <Box w="3" h="3" bg="gray.300" borderRadius="full" />
            <Box w="3" h="3" bg="gray.300" borderRadius="full" />
            <Box w="8" h="3" bg="gray.400" borderRadius="full" />
            <Box w="3" h="3" bg="gray.300" borderRadius="full" />
            <Box w="3" h="3" bg="gray.300" borderRadius="full" />
            <Box w="3" h="3" bg="gray.300" borderRadius="full" />
          </Flex>

     
          <Button
            variant="solid"
            colorScheme="teal"
            isRound
            size="lg"
            bg="teal.500"
            _hover={{ bg: "teal.600" }}
            className="shadow-lg"
          >
            <Icon
              icon="material-symbols:arrow-forward"
              className="text-white text-xl"
            />
          </Button>
        </Flex> */}
    </>
  );
};

export default Essentials;
